module.exports = __webpack_public_path__ + "static/cosygiraffesage-dbf971ca571f4f8264c367230aa4c2ac.jpeg";